import { useState, useEffect } from 'react';

const KEY = 'aone.ui';

// Pure resolver — query string overrides stored preference, default 'classic'.
export function resolveUiMode(search, stored) {
  const params = new URLSearchParams(search || '');
  const q = params.get('ui');
  if (q === 'fiori' || q === 'classic') return q;
  return stored === 'fiori' ? 'fiori' : 'classic';
}

export function getStoredUiMode() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function setUiMode(mode) {
  try { localStorage.setItem(KEY, mode); } catch { /* ignore */ }
}

// Hook: resolves once on mount; a ?ui= query param also persists to storage so
// the flag survives client-side navigation that drops the query string.
export function useFioriUi() {
  const [mode, setMode] = useState(() =>
    resolveUiMode(window.location.search, getStoredUiMode()));
  useEffect(() => {
    const resolved = resolveUiMode(window.location.search, getStoredUiMode());
    if (resolved !== getStoredUiMode()) setUiMode(resolved);
    setMode(resolved);
  }, []);
  return [mode === 'fiori', (on) => {
    const next = on ? 'fiori' : 'classic';
    setUiMode(next);
    setMode(next);
  }];
}
